// extracted by mini-css-extract-plugin
export default {"container":"QnaList_container__Kvv1q","head":"QnaList_head__oO99z","body":"QnaList_body__OiBcx","column":"QnaList_column__p-g3R"};